import { render, staticRenderFns } from "./CampaignsEdit.vue?vue&type=template&id=ad8e87d8&"
import script from "./CampaignsEdit.vue?vue&type=script&lang=js&"
export * from "./CampaignsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports